import { createContext, useContext } from 'react';

export interface PaymentPreviewSummary {
  settlementType?: string;
  settlementAmount?: number;
  pipAmount?: number;
  lienReimbursementAmount?: number;
}

export interface SettlementContextType {
  refreshSettlement: () => void;
  setPaymentPreviewSummary: (summary: PaymentPreviewSummary) => void;
  registerPaymentPreviewRefresh: (refresh: () => void) => void;
  refreshPaymentPreview: () => void;
}

export const SettlementContext = createContext<SettlementContextType | undefined>(undefined);

export const useSettlementContext = () => {
  const context = useContext(SettlementContext);
  if (!context) {
    throw new Error('useSettlementContext must be used within a SettlementContextProvider');
  }
  return context;
};
